import { frontendURL } from '../../../../helper/URLHelper';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: [
    'campaigns_sms_index',
    'campaigns_livechat_index',
    'campaigns_email_index',
    'campaigns_email_templates_index',
  ],
  menuItems: [
    {
      icon: 'arrow-swap',
      label: 'LIVE_CHAT',
      key: 'ongoingCampaigns',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/live_chat`),
      toStateName: 'campaigns_livechat_index',
    },
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'SMS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/sms`),
      toStateName: 'campaigns_sms_index',
    },
    {
      key: 'emailCampaigns',
      icon: 'mail',
      label: 'EMAIL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/email`),
      toStateName: 'campaigns_email_index',
    },
    {
      key: 'emailCampaignTemplates',
      icon: 'document',
      label: 'EMAIL_TEMPLATES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/email_templates`),
      toStateName: 'campaigns_email_templates_index',
    },
  ],
});

export default campaigns;
